export default {
      id: "icon-page-usage",
      viewBox: "0 0 65 73",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#icon-page-usage",
      toString: function () {
        return this.url;
      }
    }